import {Component, OnInit} from '@angular/core';
import {ElectronService} from 'ngx-electron';
import {Tab} from '../../../tabbing/data/tab';
import {NavigationService} from '../../services/navigation.service';
import {TabbingService} from '../../../tabbing/services/tabbing.service';
import {UserService} from '../../../user/services/user/user.service';
import {ColorService} from '../../services/color/color.service';
import {TenantService} from "../../../auth/services/tenant/tenant.service";

@Component({
  selector: 'app-headless-window',
  templateUrl: './headless-window.component.html',
  styleUrls: ['./headless-window.component.scss']
})
export class HeadlessWindowComponent implements OnInit {
  headlessTab: Tab;

  constructor(public electronService: ElectronService,
              private navigationService: NavigationService,
              private tabbingService: TabbingService,
              private userService: UserService,
              private tenantService: TenantService,
              private colorService: ColorService) { }

  ngOnInit(): void {
    this.headlessTab = Tab.getDefault();
    const route = window.location.pathname;
    this.headlessTab.navigationData.route = {
      path: route,
    };
    let queryParamsString = window.location.search;
    if (queryParamsString) {
      if (queryParamsString.startsWith('?')) {
        queryParamsString = queryParamsString.substring(1);
      }
      this.headlessTab.navigationData.queryParams = {};
      const queryParams = queryParamsString.split('&');
      for (const queryParam of queryParams) {
        const split = queryParam.split('=');
        if (split.length === 2) {
          this.headlessTab.navigationData.queryParams[split[0]] = split[1];
        }
      }
    }
    this.tabbingService.tabs = [];
    this.tabbingService.tabs.push(this.headlessTab);
    this.tabbingService.visibleTab = this.headlessTab;
    setTimeout(() => {
      this.navigationService.navigate(this.headlessTab, [this.headlessTab.navigationData.route.path], {queryParams: this.headlessTab.navigationData.queryParams});
    }, 1000);
  }

}
